import BaseComponent from "../../common/BaseComponent/BaseComponent";
import {ContextCart} from "../../context/ContextCartProvider";

class ComponentCartContextMiddleware extends BaseComponent {

	static contextType = ContextCart;

	eventConsume(actionName, actionObject) {

		if (actionName === 'ContextCartUpdate') {
			this.context.setContextData(actionObject);
		}

	}

	render() {
		return null;
	}
}

export default ComponentCartContextMiddleware;